import React, { Component, ReactNode } from 'react'
import { startCase } from 'lodash'
import { t, Trans } from '@lingui/macro'

import { Modal } from '../modal/Modal'
import { notification } from '../notifications/Notifications'
import { ButtonClean, ButtonDanger } from 'front-end/src/components'

interface IProps {
  show: boolean
  entityName: string
  operation: () => Promise<any>
  onCanceled?: () => void
  onDeleted?: () => void
  body?: string
  header?: string
  cancelButton?: string
  confirmButton?: string
  actionName?: string
  onSuccessMessage?: string
  onErrorMessage?: string
}

interface IState {
  isDeleting: boolean
}

// TODO refactor to FC
export default class GeneralRemoveModal extends Component<IProps, IState> {
  state: IState = {
    isDeleting: false
  }

  handleOnDelete = async (): Promise<void> => {
    const { operation, onDeleted, entityName } = this.props

    this.setState({ isDeleting: true })

    try {
      await operation()
      notification.info(
        `${startCase(entityName)} ${
          this.props.onSuccessMessage || t`has been deleted`
        }`
      )
    } catch (e) {
      notification.error(
        `${this.props.onErrorMessage || t`Error deleting`} ${entityName}`
      )
    }

    this.setState({ isDeleting: false })

    onDeleted && onDeleted()
  }

  renderControls(): JSX.Element {
    const { onCanceled, entityName, cancelButton, confirmButton } = this.props

    const { isDeleting } = this.state

    return (
      <>
        <ButtonClean onClick={onCanceled}>
          {cancelButton || <Trans>Cancel</Trans>}
        </ButtonClean>
        <ButtonDanger
          isLoading={isDeleting}
          onClick={this.handleOnDelete}
          dataTest="ArchiveButton"
        >
          {confirmButton || <Trans>Delete this ${entityName}</Trans>}
        </ButtonDanger>
      </>
    )
  }

  render(): ReactNode {
    const { onCanceled, show, entityName, header, body, actionName } =
      this.props

    return (
      <Modal
        header={header || t`Delete ${entityName}`}
        show={show}
        controls={this.renderControls()}
        onHide={onCanceled}
      >
        <p>
          {body || (
            <Trans>
              Are you sure you want to {actionName ? actionName : t`delete`}{' '}
              this {entityName}?<br />
              This action cannot be undone
            </Trans>
          )}
        </p>
      </Modal>
    )
  }
}
